import { Button, ButtonVariants } from '@components/button/Button';
import { Calendar } from '@components/calendar/Calendar';
import { Divider } from '@components/divider/Divider';
import { GuestCountPicker } from '@components/guestCountPicker/GuestCountPicker';
import cx from 'classnames';
import { useState } from 'react';
import typography from '~styles/typography.scss';
import { useRestaurant } from '../../context/useRestaurant';
import styles from './DateAndGuestCountFilterPill.scss';

interface FilterPopoverProps {
  onApply: (date: Date, guestCount: number) => void;
  selectedDate: Date;
  selectedGuestCount: number;
  minimumDate?: Date;
}

export const FilterPopover = ({
  onApply,
  selectedDate,
  selectedGuestCount,
  minimumDate,
}: FilterPopoverProps) => {
  const { maxReservationGuests } = useRestaurant();

  const [date, setDate] = useState<Date>(selectedDate);
  const [guestCount, setGuestCount] = useState(selectedGuestCount);
  const handleApply = () => onApply(date, guestCount);

  return (
    <div
      className={styles.popover}
      data-testid="date-and-guest-count-filter-popover"
    >
      <GuestCountPicker
        className={styles.guestCountPicker}
        guestCount={guestCount}
        max={maxReservationGuests}
        onChange={setGuestCount}
      />
      <Divider className={styles.divider} />
      <h1 className={cx(typography.h7, styles.selectDate)}>Select Date</h1>
      <Calendar minDate={minimumDate} onDateChange={setDate} value={date} />
      <Button
        className={styles.applyButton}
        label="Apply"
        onClick={handleApply}
        variant={ButtonVariants.Primary}
      />
    </div>
  );
};
